import { api } from '_api';

import type { Login, LoginWithGoogleReq } from "_types/requests/auth";
import type { CurrentUser, LoggedIn } from "_types/responses/auth";
import type { Finder, Mutator } from '_types/swr';

import { unwrap } from '_utils/axios';
import { parseKey } from '_utils/swr';
import { NoContent } from "_types";
import { PartialCourt } from '_types/models/Court';

export const login: Mutator<LoggedIn, Login> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<LoggedIn>(url, payload);

    return await unwrap(response);
};

export const loginWithGoogle: Mutator<LoggedIn, LoginWithGoogleReq> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<LoggedIn>(url, payload);

    return await unwrap(response);
};

export const currentUser: Finder<CurrentUser> = async ({ queryKey }) => {
    const url = parseKey(queryKey);
    const response = await api.get<CurrentUser>(url);

    return await unwrap(response);
};

export const logout: Mutator<NoContent, NoContent> = async (queryKey) => {
    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url);

    return await unwrap(response);
}

export const forgetPassword: Mutator<NoContent, { email: string, captcha: string }> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url, payload);

    return await unwrap(response);
}

export const resetPassword: Mutator<NoContent, {
    email: string,
    token: string,
    password: string
}> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url, payload);

    return await unwrap(response);
}


export const getCourts: Finder<PartialCourt[]> = async ({ queryKey }) => {
    const url = parseKey(queryKey);
    const response = await api.get<PartialCourt[]>(url);

    return await unwrap(response);
};

export const selectCourt: Mutator<LoggedIn, { courtId: string; }> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<LoggedIn>(url, payload);

    return await unwrap(response);
};


export const updateCourt: Mutator<LoggedIn, { courtId: string; }> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.patch<LoggedIn>(url, payload);

    return await unwrap(response);
};
